const getBreakTitle = ({ breakCode, t }) => {
  switch (breakCode) {
    case 'ISTIRAHAT_MAKAN':
      return t('clock_in_view.mealBreakText');
    case 'TOILET':
      return t('clock_in_view.toiletBreakText');
    case 'SHOLAT':
      return t('clock_in_view.prayBreakText');
    case 'BANTU_REKAN':
      return t('clock_in_view.helpPartnerText');
    default:
      return t('clock_in_view.defaultRestText');
  }
};

export default getBreakTitle;
